import axios from "axios";

export const getAvailableDashboard = data => {
  const requestUrl = `/data/dashboards`;
  let {
    pageSize,
    paginationPage,
    labels,
    legalForms,
    uen,
    status,
    backOffice,
    isPublic,
    operator,
    filterStatus,
    newDashboardIds
  } = data;
  const fields = [];
  let filter = [];

  if (labels && labels.length > 0) {
    filter.push({
      property: "labels",
      value: labels,
      operator: "like"
    });
  }
  if (newDashboardIds && newDashboardIds.length > 0) {
    filter.push({
      property: "id",
      value: newDashboardIds,
      operator: "in"
    });
  }

  if (backOffice) {
    filter.push({
      property: "status",
      value: "STANDARD",
      operator: "eq"
    });
  } else if (status && status.length > 0) {
    filter.push({
      property: "status",
      value: status.toString(),
      operator: "eq"
    });
  }
  if (legalForms && legalForms.length > 0) {
    let legalform = legalForms.map(({ value }) => value);
    filter.push({
      property: "legalForms",
      value: legalform.toString(),
      operator: "like"
    });
  }
  if (isPublic && operator) {
    filter.push({
      property: "isPublic",
      value: isPublic.toString(),
      operator: operator.toString()
    });
  }
  let sort = [];

  sort.push({
    property: "createdAt",
    dir: "desc"
  });

  let params = {
    fields: fields.join(","),
    limit: pageSize || 12,
    start: !paginationPage ? 0 : (paginationPage - 1) * pageSize,
    uen: uen,
    filterStatus: filterStatus
  };

  params.filter = JSON.stringify(filter).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};

export const deleteDashboardApi = ({ id }) => {
  const requestUrl = `/data/delete-dashboard`;

  let formData = new FormData();
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};
export const duplicateDashboard = ({ uen, id, status, isBackOffice }) => {
  const requestUrl = `/data/duplicate-dashboard`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);
  formData.append("status", status);
  formData.append("isBackOffice", isBackOffice);

  return axios.post(requestUrl, formData);
};
export const updatePrivacyDashboard = ({ id, isEditable }) => {
  const requestUrl = `/data/update-dashboard-privacy`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isEditable", isEditable);

  return axios.post(requestUrl, formData);
};
export const updateStateDashboard = ({ uen, id }) => {
  const requestUrl = `/data/update-dashboard-state`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("uen", uen);
  return axios.post(requestUrl, formData);
};
export const setDashboardPrivate = ({ id }) => {
  const requestUrl = `/data/set-dashboard-private`;

  let formData = new FormData();
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};
export const useSharedDashboardApi = ({ uen, id }) => {
  const requestUrl = `/data/use-shared-dashboard`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("uen", uen);
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/dashboardList.js